import { shipServiceService } from '@services';
import toastMessageType from '@constant/ToastMessage';
import { masterService } from '@/domain/services';

class ShipController {
  getAll = async (cancelSignal, setShipServices) => {
    try {
      const result = await shipServiceService.getAll(cancelSignal);

      if (!result.error) {
        setShipServices(result);
      }
    } catch (err) {
      if (err.name == 'AbortError') {
        console.log('Aborted!');
      }
    }
  };

  update = async ({
    user,
    shipService,
    setToastMessage,
    fetchShipServices,
    closeEditButton,
  }) => {
    try {
      await masterService.updateShipService({
        user,
        shipService,
      });

      setToastMessage({
        isVisible: true,
        type: toastMessageType.SUCCESS,
        msg: {
          title: 'Thành công',
          duration: 3000,
          desc: 'Cập nhật thành công',
        },
      });
      fetchShipServices();
      closeEditButton();
    } catch (err) {
      setToastMessage({
        isVisible: true,
        type: toastMessageType.ERROR,
        msg: {
          title: 'Lỗi',
          duration: 3000,
          desc: 'Không thể cập nhật',
        },
      });
    }
  };

  create = async ({
    user,
    shipService,
    setToastMessage,
    fetchShipServices,
    closeEditButton,
  }) => {
    try {
      const result = await masterService.createShipService({
        user,
        shipService,
      });

      setToastMessage({
        isVisible: true,
        type: toastMessageType.SUCCESS,
        msg: {
          title: 'Thành công',
          duration: 3000,
          desc: 'Cập nhật thành công',
        },
      });
      fetchShipServices();
      closeEditButton();
    } catch (err) {
      setToastMessage({
        isVisible: true,
        type: toastMessageType.ERROR,
        msg: {
          title: 'Lỗi',
          duration: 3000,
          desc: 'Không thể cập nhật',
        },
      });
    }
  };
}

export default ShipController;
